module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.definition) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "report"
  }, [_c('el-menu', {
    staticClass: "flex items-center px-30 h-60",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('div', {
    staticClass: "flex gap items-center grow"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "grow"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.navigateTo
    },
    model: {
      value: (_vm.selectedReport),
      callback: function($$v) {
        _vm.selectedReport = $$v
      },
      expression: "selectedReport"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mr-4"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exporting),
      expression: "exporting"
    }],
    attrs: {
      "disabled": _vm.exporting
    },
    on: {
      "click": _vm.onExport
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('v-custom-date-range-picker', {
    on: {
      "dateRange": function (v) {
        _vm.dateRange = v;
      }
    }
  })], 1), _vm._v(" "), (_vm.definition) ? _c('div', {
    staticClass: "p-30"
  }, [_c('el-card', {
    staticClass: "mb-20 report__filter",
    attrs: {
      "shadow": "none"
    }
  }, [_c('div', {
    staticClass: "title mb-5"
  }, [_vm._v("Filter")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Coupon")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filterResults.coupon),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "coupon", $$v)
      },
      expression: "filterResults.coupon"
    }
  }, _vm._l((_vm.filterOptions.coupon), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Customer group")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filterResults.customerGroup),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "customerGroup", $$v)
      },
      expression: "filterResults.customerGroup"
    }
  }, _vm._l((_vm.filterOptions.customerGroup), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filterResults.gender),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "gender", $$v)
      },
      expression: "filterResults.gender"
    }
  }, _vm._l((_vm.filterOptions.gender), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Origin")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filterResults.origin),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "origin", $$v)
      },
      expression: "filterResults.origin"
    }
  }, _vm._l((_vm.filterOptions.origin), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex mt-4"
  }, [_c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Categories")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select",
      "multiple": ""
    },
    model: {
      value: (_vm.filterResults.categories),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "categories", $$v)
      },
      expression: "filterResults.categories"
    }
  }, _vm._l((_vm.filterOptions.categories), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Payment")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select",
      "multiple": ""
    },
    model: {
      value: (_vm.filterResults.payment),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "payment", $$v)
      },
      expression: "filterResults.payment"
    }
  }, _vm._l((_vm.filterOptions.payment), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-4 w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Products")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Search",
      "multiple": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.getProductsBySearch,
      "no-data-text": "No search result found",
      "no-match-text": "No search result found"
    },
    model: {
      value: (_vm.filterResults.products),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "products", $$v)
      },
      expression: "filterResults.products"
    }
  }, _vm._l((_vm.filterOptions.products), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-1/4"
  }, [_c('div', {
    staticClass: "report__filter-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select",
      "multiple": ""
    },
    model: {
      value: (_vm.filterResults.status),
      callback: function($$v) {
        _vm.$set(_vm.filterResults, "status", $$v)
      },
      expression: "filterResults.status"
    }
  }, _vm._l((_vm.filterOptions.status), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "end"
    }
  }, [_c('el-col', {
    staticClass: "mb-20",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.onBack
    }
  }, [_vm._v("Back to overview")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mb-20",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [(_vm.reportData && _vm.reportData.length > 0) ? _c('div', {
    staticClass: "flex gap justify-end"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.filterReport
    },
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  }, _vm._l((_vm.reportFilterOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.definition.filterTabs) ? _c('el-radio-group', {
    model: {
      value: (_vm.groupBy),
      callback: function($$v) {
        _vm.groupBy = $$v
      },
      expression: "groupBy"
    }
  }, _vm._l((_vm.definition.filterTabs), function(el) {
    return _c('el-radio-button', {
      key: el,
      attrs: {
        "label": el
      }
    }, [_vm._v(_vm._s(el))])
  }), 1) : _vm._e()], 1) : _vm._e()])], 1), _vm._v(" "), (
    _vm.definition.table &&
    _vm.reportData &&
    _vm.reportData.length > 0 &&
    _vm.chartData.values &&
    !_vm.chartData.values.every(function (e) { return e === 0; })
  ) ? _c('el-card', {
    staticClass: "mb-20",
    attrs: {
      "shadow": "none"
    }
  }, [(_vm.definition.chart === 'BAR_AND_LINE') ? _c('chart-bar-and-line', {
    attrs: {
      "data": _vm.chartData
    }
  }) : (_vm.definition.chart === 'PIE') ? _c('chart-pie', {
    attrs: {
      "data": _vm.chartData
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.definition.table && _vm.reportData) ? _c('el-table', {
    staticClass: "w-full",
    attrs: {
      "data": _vm.reportData,
      "stripe": ""
    }
  }, _vm._l((_vm.definition.table), function(def, index) {
    return _c('el-table-column', {
      key: def.key,
      attrs: {
        "label": def.label,
        "prop": def.key,
        "sortable": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(
            _vm.selectedReport === 'best_seller' &&
            _vm.reportData.length > 20 ?
            scope.$index !== _vm.reportData.length - 1 :
            true
          ) ? _c('div', {
            staticClass: "flex items-center"
          }, [(
            index === 0 &&
            _vm.reportData.length <= _vm.chartColors.length
          ) ? _c('span', {
            staticClass: "chart-color-indicator",
            style: ({
              background: _vm.chartColors[scope.$index],
            })
          }) : _vm._e(), _vm._v(" "), (def.format === 'DATE') ? _c('span', [_vm._v(_vm._s(_vm._f("date")(scope.row[scope.column.property])))]) : (def.format === 'CURRENCY') ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(scope.row[scope.column.property],
            scope.row['currency'] ?
            scope.row['currency'] :
            _vm.defaultCurrency
          )))]) : _c('span', [_vm._v(_vm._s(scope.row[scope.column.property]))])]) : _vm._e()]
        }
      }], null, true)
    })
  }), 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8aa18650"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportDetail.vue
// module id = 550
// module chunks = 1